import {Component, OnInit} from "@angular/core";

@Component({
    standalone: false,
  selector: "azure",
  templateUrl: 'azure.component.html',
  styleUrls: ['./azure.component.scss'],
})

export class AzureComponent implements OnInit {

  constructor(
) {
  }

  ngOnInit() {

  }


}
